import axios from "axios";
import { API_URL } from "../configs/config";

export function getMobileUIVersion() {
  let headers = {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  };

  axios
    .get(`${window.location.origin}/mobileUiVersion.json`, { headers: headers })
    .then((res) => {
      if (
        localStorage.getItem("mobileUiVersion") != null &&
        localStorage.getItem("mobileUiVersion") != undefined
      ) {
        if (localStorage.getItem("mobileUiVersion") !== res.data.buildVersion) {
          localStorage.setItem("mobileUiVersion", res.data.buildVersion);
          window.location.href =
            window.location.origin + window.location?.pathname;
        }
      } else {
        localStorage.setItem("mobileUiVersion", res.data.buildVersion);
      }
      if (
        localStorage.getItem("fdaVersion") != null &&
        localStorage.getItem("fdaVersion") != undefined
      ) {
        if (localStorage.getItem("fdaVersion") !== res.data.FDA) {
          localStorage.setItem("fdaVersion", res.data.FDA);
        }
      } else {
        localStorage.setItem("fdaVersion", res.data.FDA);
      }
    });
}

function clear() {
  let userEmail = JSON.parse(localStorage.getItem("loggedInUserName") || "[]");
  localStorage.clear();
  sessionStorage.clear();
  localStorage.setItem(
    "loggedInUserName",
    JSON.stringify({ email: userEmail.email! })
  );
  window.location.href = window.location.origin + "/login";
}

const instance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Application-Id": "d MyApp",
  },
});

instance.interceptors.request.use(
  (config: any) => {
    const loggedInUsertoken = localStorage.getItem("TokenID");
    if (
      loggedInUsertoken != "" &&
      loggedInUsertoken != null &&
      loggedInUsertoken != undefined
    ) {
      config!.headers!["Authorization"] = `Bearer ${localStorage.getItem(
        "TokenID"
      )}`;
    }
    config!.headers!["Device-Id"] = localStorage.getItem("device_id") || "";
    if (config.method !== "get") config.data.applicationLookup = 5;

    return config;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (err.code === "ERR_NETWORK") {
      console.error("Network error:", err);
      if (err.message === "Network Error") {
        clear();
      }
    } else if (err.response) {
      if (err.response.status === 401) {
        clear();
      }
      if (
        (err.response.status === 0 || err.response.status === 400) &&
        !originalConfig._retry
      ) {
        originalConfig._retry = true;
      }
    } else {
      console.error("Network error or no response from server:", err);
    }

    return Promise.reject(err);
  }
);

export default instance;
